import { render, staticRenderFns } from "./PostponeLogo.vue?vue&type=template&id=6c159dd6&scoped=true&"
import script from "./PostponeLogo.vue?vue&type=script&lang=js&"
export * from "./PostponeLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c159dd6",
  null
  
)

export default component.exports